import glamorous from "glamorous"
import style from "utils/style"

const HeadingInitial = glamorous.h1({
  color: style.colors.almostBlack,
  fontSize: "3rem",
  fontWeight: 700,
  paddingTop: 15,
  paddingBottom: 25,
  marginBottom: 17,
  borderBottom: `1px solid ${style.colors.darkerGray}`,
})

export default HeadingInitial



// WEBPACK FOOTER //
// ./src/elements/HeadingInitial.js